const RoleEnum = {
    'SUPER_ADMIN' : 999,
    'PROJECT_MANAGER': 110,
    'PROJECT_MEMBER' : 100,
    'MATERIAL_REPOSITORY_MEMBER': 200,
    'MATERIAL_REPOSITORY_MANAGER': 210,
    'NORMAL_USER': 1
};

const EfmStatus = {
    'LABELING' : {
        name: '标注中',
        description: '处于标注阶段',
        color: '#52c41a'
    },
    'WAITING_AUDIT' : {
        name: '审核中',
        description: '等待审核',
        color: 'gold'
    },
    'AUDITED' : {
        name: '已审核',
        description: '已审核,等待归档',
        color: 'cyan'
    },
    'ARCHIVED' : {
        name: '已归档',
        description: '不可再修改',
        color: 'gray'
    }
}

const LabelingTaskStatus = ['LABELING', 'WAITING_AUDIT', 'AUDITED', 'ARCHIVED'];


const LabelSubtypePositionEnum = ['ALL', 'FHR',  '', 'PART'];


const TakePhotosStatus = {
    'COMMIT' : {
        name: '待处理',
        description: '提交成功等待处理',
        color: '#1677ff'
    },
    'SUCCESS' : {
        name: '已采纳,待导入',
        description: '提交被采纳',
        color: '#2db7f5'
    },
    'FAIL' : {
        name: '未采纳',
        description: '提交未被采纳',
        color: '#ff4d4f'
    },
    "IMPORT": {
        name: '已导入',
        description: '报告被导入',
        color: '#52c41a'
    }
}

const StudyPlanStatus = {
    'WAITING':{
        name:'待开始',
        color:'gray'
    },
    'RUNING':{
        name:'进行中',
        color:'#52c41a'
    },
    'END':{
        name:'已结束',
        color:'cyan'
    }
}

const EfmDataType = {
    'FHR' :{
        name: 'FHR',
        color: 'gray'
    },
    'UC' :{
        name: 'UC',
        color: 'gray'
    },
    'BO' :{
        name: 'BO',
        color: 'gray'
    },
    'FM' :{
        name: 'FM',
        color: 'gray'
    }
}

const StudyPlanStudentStatus = {
    'WAITING':{
        name:'待开始',
        color:'gray'
    },
    'BASE_TEST':{
        name:'基准测试',
        color:'#1d39c4'
    },
    'RUNING':{
        name:'进行中',
        color:'#1d39c4'
    },
    'EXAMINE':{
        name:'待考核',
        color:'#1677ff'
    },
    'MAKE_UP_TEST':{
        name:'待补考',
        color:'#247dfa'
    },
    'PASS':{
        name:'通过',
        color:'#52c41a'
    },
    'NOT_PASS':{
        name:'未通过',
        color:'#cd201f'
    }
}

const PermissionType = {
    'API':{
        name:'接口',
        color:'#1d39c4'
    },
    'BUTTON':{
        name:'按钮',
        color:'#52c41a'
    },
    'LINK':{
        name:'链接',
        color:'#cd201f'
    },
    'NAV':{
        name:'导航',
        color:'#cd201f'
    }
}

const  ExaminationType = {
    'TEST':{
        name:'结课测试题',
        color:'#cd201f'
    },
    'MAKE_UP_TEST':{
        name:'结课补考题',
        color:'#52c41a'
    },
    'BASE_TEST':{
        name:'基准测试题',
        color:'#1677ff'
    },
}

const TagType = {
    "LABEL" : {
        name : "标注"
    },
    "EFM_SEGMENT": {
        name: "素材片段"
    },
    "COURSE" : {
        name : "课程"
    }
}

const deliveryModeOptions: Option[] = [
    {
        value: '阴道分娩',
        label: '阴道分娩',
        children: [
            {
                value: '阴道分娩',
                label: '（全部）'
            },
            {
                value: '顺产',
                label: '顺产'
            },
            {
                value: '吸引产',
                label: '吸引产'
            },
            {
                label: '钳产',
                value: '钳产'
            }, {
                label: '臀助产',
                value: '臀助产'
            }, {
                label: '臀牵引',
                value: '臀牵引'
            }
        ],
    },
    {
        value: '剖宫产',
        label: '剖宫产',
        children: [
            {
                value: '剖宫产',
                label: '（全部）'
            },
            {
                value: '剖宫产-试产失败',
                label: '试产失败'
            },
            {
                value: '剖宫产-不确定',
                label: '不确定'
            },
            {
                value: '剖宫产-急诊',
                label: '急诊'
            },
            {
                value: '剖宫产-择期',
                label: '择期'
            },
            {
                value: '剖宫产-待查',
                label: '待查'
            }
        ]
    }
];


const temperatureThreshold = 38;


export {EfmStatus,LabelingTaskStatus,LabelSubtypePositionEnum,RoleEnum,StudyPlanStatus,StudyPlanStudentStatus,PermissionType,ExaminationType, TagType, EfmDataType, TakePhotosStatus, deliveryModeOptions, temperatureThreshold}
